<script lang="ts" setup>
import { PoolDetails } from "@/models/pool-details.model";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";
import { usePool } from "@/features/pool/usePool";
import { computed } from "vue";
import {
  getActiveMode,
  getOutByIndex,
  getOutIcon,
  isOutHiddenForHivernage,
} from "@/shared/utils/outs";
import { getRename } from "@/shared/utils/renames";
import OnOffStatus from "@/features/out/OnOffStatus.vue";
import { isHivernage } from "@/shared/utils/pool";
import { useRoute } from "vue-router";

const props = defineProps<{
  out: PoolDetails["outs"][number];
}>();

const pool = usePool();

const modeDef = computed(() => getActiveMode(props.out, pool));

const label = computed(
  () =>
    getRename(pool, 1, props.out.index) ?? getOutByIndex(props.out.index).label
);

const name = computed(() => getOutByIndex(props.out.index).name);

const hiddenForHivernage = computed(
  () => isHivernage(pool) && isOutHiddenForHivernage(props.out.index)
);

const icon = computed(() => getOutIcon(name.value));

const route = useRoute();

const linkTarget = computed(() =>
  name.value === "OUT_CHAUF" && pool.EauCapteur
    ? `/pool/${route.params.poolId}/probe/${pool.EauCapteur}`
    : `/pool/${route.params.poolId}/out/${props.out.index}`
);
</script>

<template>
  <div
    class="card text-center p-4 font-medium cursor-pointer flex flex-col items-center"
    @click="$router.push(linkTarget)"
  >
    <div class="measure-name">{{ $t(label) }}</div>

    <klereo-icon v-if="icon" :name="icon" folder="outs" class="m-2 w-[66px]" />

    <div class="text-sm uppercase mt-2">
      {{
        hiddenForHivernage
          ? $t("RegulHivernage")
          : $t(modeDef?.label ?? "Unknown")
      }}
    </div>

    <on-off-status
      v-if="modeDef?.showStatus && !hiddenForHivernage"
      :out="out"
      class="justify-center"
    />
  </div>
</template>
